export const config: { [x: string]: any } = {
  env: process.env.REACT_APP_ENV,
  game: (process.env.REACT_APP_GAMETYPE || 'bingo'),

  apiUrl: process.env.REACT_APP_APIURL,
  bingo: process.env.REACT_APP_BINGO_URL,
  solitaire: process.env.REACT_APP_SOLITAIRE_URL,
  bubble: process.env.REACT_APP_BUBBLE_URL,

  billing: process.env.REACT_APP_BILLING_URL,

  commonURL: (process.env.REACT_APP_COMMON_URLS || '').split(',').filter(Boolean)
}